import React from 'react';
import MatchingLabel from './matchingLabel';
import ReactTooltip from 'react-tooltip';

const tooltipData = "We will contribute a matching amount of your first month's donation to this program from our side to help you increase the impact of your contribution"
class MatchingIcon extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.matchingIconRef = React.createRef(); 
	}

render() {
	const { matchingPercentage, height, id } = this.props;
	return (
		<React.Fragment>
		<div className="tooltip-matching-desktop d-flex f-d-row align-self-center"  data-tip={tooltipData} data-place="right" data-for={`tooltip-matching-${id}`}>
		<MatchingLabel height={height}/>
			{
				window ?
					<ReactTooltip   id={`tooltip-matching-${id}`} ref={this.matchingIconRef} data-multiline={true} data-event="click"/>
				 : null
			}
				
			<div
				style={{ 
						background: "#42A98B", 
						margin: '0px 0px 0px -5px', 
						alignSelf: 'center',
						borderTopRightRadius: '5px',
						borderBottomRightRadius: '5px'
					}}>
				<p
					style={{
						lineHeight: 1,
						fontSize: '12px',
						color: '#ffffff',
						padding: '4px 10px',
						fontWeight: 800,
						margin: 0,
						whiteSpace: 'nowrap',	
					}}
				>{matchingPercentage}% Matched </p>
			</div>
		</div>
		<div className="tooltip-matching-mobile d-flex f-d-row align-self-center"  data-tip={tooltipData} data-place="top" data-for={`tooltip-matching-${id}`}>	
			<MatchingLabel height={height}/>
			{
				window ?
					<ReactTooltip   id={`tooltip-matching-${id}`} ref={this.matchingIconRef} data-multiline={true} data-event="click"/>
				 : null
			}
				
			<div
				style={{ 
						background: "#42A98B", 
						margin: '0px 0px 0px -5px', 
						alignSelf: 'center',
						borderTopRightRadius: '5px',
						borderBottomRightRadius: '5px'
					}}>
				<p
					style={{
						lineHeight: 1,
						fontSize: '12px',
						color: '#ffffff',
						padding: '4px 10px',
						fontWeight: 800,
						margin: 0,
						whiteSpace: 'nowrap',	
					}}
				>{matchingPercentage}% Matched </p>
			</div>	
		</div>
		<style global jsx>
			{
				`
					.__react_component_tooltip {
						width: 300px !important;
					}

					@media (min-width: 768px) {
						.tooltip-matching-desktop {
							display: flex !important;
						}

						.tooltip-matching-mobile {
							display: none !important; 
						}
					}

					@media (max-width: 556px) {
						.tooltip-matching-desktop {
							display: none !important;
						}

						.tooltip-matching-mobile {
							display: flex !important; 
						}	
					}
					
				`
			}
		</style>
		</React.Fragment>
	)
}	
	
}

export default MatchingIcon;
